module.exports = __webpack_public_path__ + "media/SudRadio11062011.c94ecdb6.mp3";